import React from 'react';
import { textEllipsis } from '../../../shared/utils/constants';

export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    {
      title: t('general.title'),
      field: 'title',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { title } = rowData;
        return (
          <span className="tooltip-test" title={title}>
            {title}
          </span>
        );
      },
    },
    { title: t('general.active'), field: 'activeDescription' },
    {
      title: t('general.type'),
      field: 'typeDescription',
      cellStyle: textEllipsis,
      render: (rowData) => {
        const { typeDescription } = rowData;
        return (
          <span className="tooltip-test" title={typeDescription}>
            {typeDescription}
          </span>
        );
      },
    },
    { title: t('general.tags'), field: 'tags' },
  ];
}
